import { ApiRoutes } from '../../app/shared/models/api-routes.interface';
import { environment } from '../environment';

const apiUrl = environment.apiUrl;
const mobileApiUrl = `${environment.baseUrl}/mobile`;
const withOptionalOtpTestFlag = (url: string): string =>
  environment.otp.useTestMode ? `${url}?test=true` : url;

export const apiRoutes: ApiRoutes = {
  cardmate: {
    interest: {
      listAll: `${apiUrl}/gateway/v1/interests/list`,
    },
  },
  gateway: {
    otp: {
      send: withOptionalOtpTestFlag(`${mobileApiUrl}/gateway/v1/otp/send`),
      verify: withOptionalOtpTestFlag(`${mobileApiUrl}/gateway/v1/otp/verfiy`),
    },
    mobileAuth: {
      register: `${mobileApiUrl}/gateway/v1/auth/register`,
      refreshToken: `${mobileApiUrl}/gateway/v1/auth/users/refresh`,
    },
    lookups: {
      subscriptionPlans: `${mobileApiUrl}/gateway/v1/lookups/subscription-plans`,
    },
    qitaf: {
      redemptionOtp: `${mobileApiUrl}/gateway/v1/auth/qitaf/redemption/otp`,
      redeem: `${mobileApiUrl}/gateway/v1/auth/qitaf/redemption/redeem`,
      reverse: `${mobileApiUrl}/gateway/v1/auth/qitaf/redemption/reverse`,
      reward: `${mobileApiUrl}/gateway/v1/auth/qitaf/earn/reward`,
    },
    subscriptions: {
      moyasar: {
        checkoutIntents: `${mobileApiUrl}/gateway/v1/auth/subscriptions/moyasar/checkout-intents`,
        confirmCheckout: (checkoutId: number | string) =>
          `${mobileApiUrl}/gateway/v1/auth/subscriptions/moyasar/checkout-intents/${checkoutId}/confirm`,
      },
      payments: {
        open: `${mobileApiUrl}/gateway/v1/auth/subscriptions/payments/open`,
      },
    },
    interestRegistration: {
      register: `${apiUrl}/gateway/v1/interest-registration`,
    },
    appContent: {
      faq: {
        list: `${apiUrl}/gateway/v1/faq`,
        getById: (id: number | string) => `${apiUrl}/gateway/v1/faq/${id}`,
      },
      helpSupport: {
        contact: `${apiUrl}/gateway/v1/help-support/contact`,
      },
      legalDocument: {
        list: `${apiUrl}/gateway/v1/legal`,
      },
    },
  },
};
